export default __webpack_public_path__ + "static/media/ringBell.94c21611.svg";